/* Zemiro — landing. Cala logika sekcji mt-*. */
(function () {
  'use strict';

  var RM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function money(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' zł';
  }

  /* ---------- 1. pasek promocyjny: licznik + wysokosc ---------- */
  /* Licznik jest CYKLICZNY — odlicza do najblizszej polnocy i startuje od nowa.
     Tak zostalo zamowione przez wlasciciela sklepu. Nie "naprawiaj" tego na date konca promocji. */
  function countdown() {
    var sec = $('[data-mt-cd]');
    if (!sec || sec.__mt) return;
    sec.__mt = 1;
    var out = $('[data-mt-clock]', sec);
    function tick() {
      var now = new Date();
      var end = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0, 0);
      var d = Math.max(0, Math.floor((end - now) / 1000));
      var h = String(Math.floor(d / 3600)).padStart(2, '0');
      var m = String(Math.floor((d % 3600) / 60)).padStart(2, '0');
      var s = String(d % 60).padStart(2, '0');
      if (out) out.textContent = h + ':' + m + ':' + s;
    }
    tick();
    setInterval(tick, 1000);

    /* Wysokosc paska trafia do --mt-cd-h, bo o tyle nizej musi usiasc sticky naglowek motywu.
       Mierzymy tez po wczytaniu kroju pisma — pasek rosnie po podmianie fontu i przy pomiarze
       tylko na starcie naglowek zostaje z kilkupikselowa dziura nad soba. */
    function measure() {
      var h = Math.round(sec.getBoundingClientRect().height) || 42;
      document.documentElement.style.setProperty('--mt-cd-h', h + 'px');
    }
    measure();
    if (window.ResizeObserver) new ResizeObserver(measure).observe(sec);
    window.addEventListener('resize', measure);
    window.addEventListener('load', measure);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
  }

  /* ---------- 2. animacje wejscia ---------- */
  function reveal() {
    if (RM) return;
    if (window.__mtReveal) return;
    window.__mtReveal = 1;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        var delay = parseInt(el.getAttribute('data-mt-delay') || '0', 10);
        setTimeout(function () { el.classList.add('is-in'); }, delay);
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

    function arm(el, cls, delay) {
      if (el.__mt) return;
      el.__mt = 1;
      el.style.transition = 'none';
      el.classList.add(cls);
      if (delay) el.setAttribute('data-mt-delay', delay);
      void el.offsetWidth;
      el.style.transition = '';
      io.observe(el);
    }

    $$('[data-mt-r]').forEach(function (el) { arm(el, 'mt-r', 0); });
    $$('[data-mt-stagger]').forEach(function (group) {
      Array.prototype.slice.call(group.children).forEach(function (child, i) {
        arm(child, 'mt-rl', i * 95);
      });
    });

    /* bezpiecznik: jesli po 2,5 s strona jest nieprzewijalna albo nie ma szerokosci,
       odslon wszystko — inaczej tresc zostanie niewidoczna w edytorze i w podgladzie */
    setTimeout(function () {
      var stuck = window.innerWidth === 0 ||
        document.documentElement.scrollHeight <= document.documentElement.clientHeight + 4;
      if (!stuck) return;
      $$('.mt-r, .mt-rl').forEach(function (el) { el.classList.add('is-in'); });
    }, 2500);
  }

  /* ---------- 3. galeria ---------- */
  function gallery(root) {
    var gal = root || $('[data-mt-gal]');
    if (!gal || gal.__mt) return;
    gal.__mt = 1;
    var track = $('[data-mt-track]', gal);
    var slides = $$('.mt-gal__s', track);
    var thumbs = $$('[data-mt-thumb]', gal);
    var prev = $('[data-mt-gal-prev]', gal);
    var next = $('[data-mt-gal-next]', gal);
    if (!track || !slides.length) return;
    var i = 0;

    function paint() {
      thumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= slides.length - 1;
    }
    function go(n) {
      i = Math.max(0, Math.min(slides.length - 1, n));
      /* scrollTo() jest ignorowane w panelu podgladu — ustawiamy scrollLeft, plynnosc daje CSS */
      track.scrollLeft = i * track.clientWidth;
      paint();
    }
    if (prev) prev.addEventListener('click', function () { go(i - 1); });
    if (next) next.addEventListener('click', function () { go(i + 1); });
    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { go(n); }); });
    track.addEventListener('scroll', function () {
      var w = track.clientWidth || 1;
      var n = Math.round(track.scrollLeft / w);
      if (n !== i) { i = n; paint(); }
    }, { passive: true });
    paint();
  }

  /* ---------- 4. sekcja zakupowa: zestaw, ilosc, cena, koszyk ---------- */
  function buy() {
    var form = document.getElementById('mt-form');
    if (!form || form.__mt) return;
    form.__mt = 1;

    var sets = $$('[data-mt-set]', form);
    var qtyV = $('[data-mt-qv]', form);
    var qtyMinus = $('[data-mt-qm]', form);
    var qtyPlus = $('[data-mt-qp]', form);
    var now = $('[data-mt-now]', form);
    var was = $('[data-mt-was]', form);
    var tag = $('[data-mt-tag]', form);
    var btns = $$('[data-mt-add]');
    var maxQty = parseInt(form.getAttribute('data-max-qty') || '6', 10);
    var qty = 1;

    function current() {
      var c = sets.filter(function (s) { return s.checked; })[0] || sets[0];
      return c || null;
    }
    function paint() {
      var c = current();
      if (!c) return;
      var p = parseInt(c.getAttribute('data-price'), 10);
      var cmp = parseInt(c.getAttribute('data-compare') || '0', 10);
      if (now) now.textContent = money(p * qty);
      if (was) {
        if (cmp > p) { was.textContent = money(cmp * qty); was.hidden = false; }
        else was.hidden = true;
      }
      if (tag) {
        if (cmp > p) { tag.textContent = '−' + Math.round((1 - p / cmp) * 100) + '%'; tag.hidden = false; }
        else tag.hidden = true;
      }
      if (qtyV) qtyV.textContent = String(qty);
      if (qtyMinus) qtyMinus.disabled = qty <= 1;
      if (qtyPlus) qtyPlus.disabled = qty >= maxQty;
      var sn = $('[data-mt-sticky-now]');
      var sw = $('[data-mt-sticky-was]');
      if (sn) sn.textContent = money(p * qty);
      if (sw) {
        if (cmp > p) { sw.textContent = money(cmp * qty); sw.hidden = false; }
        else sw.hidden = true;
      }
    }
    sets.forEach(function (s) { s.addEventListener('change', paint); });
    if (qtyMinus) qtyMinus.addEventListener('click', function () { qty = Math.max(1, qty - 1); paint(); });
    if (qtyPlus) qtyPlus.addEventListener('click', function () { qty = Math.min(maxQty, qty + 1); paint(); });
    paint();

    /* --- szuflada koszyka zamiast przekierowania na /cart --- */
    function sectionIdOf(el) {
      if (!el) return null;
      var host = el.closest('[id^="shopify-section-"]') || el;
      var id = host.id || '';
      return id.indexOf('shopify-section-') === 0 ? id.slice(16) : null;
    }
    function drawerEl() {
      return document.querySelector('cart-drawer, theme-drawer#cart-drawer, #CartDrawer, #cart-drawer');
    }
    function headerEl() {
      return document.querySelector('[id^="shopify-section-sections--"][id$="__header"]') ||
        document.querySelector('header[id^="shopify-section-"]') ||
        document.querySelector('.shopify-section-group-header-group[id^="shopify-section-"]');
    }
    function openDrawer() {
      var d = drawerEl();
      if (!d) return false;
      if (typeof d.open === 'function') { try { d.open(); return true; } catch (e) {} }
      d.classList.remove('is-empty');
      d.classList.add('active', 'animate', 'is-open');
      document.body.classList.add('overflow-hidden');
      return true;
    }
    function swap(html, id) {
      if (!html || !id) return;
      var wrap = document.getElementById('shopify-section-' + id);
      if (!wrap) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.getElementById('shopify-section-' + id);
      wrap.innerHTML = fresh ? fresh.innerHTML : doc.body.innerHTML;
    }

    btns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var c = current();
        if (!c) return;
        var id = c.getAttribute('data-vid');
        var label = btn.querySelector('[data-mt-label]');
        var old = label ? label.textContent : '';
        if (label) label.textContent = 'Dodaję…';
        btn.disabled = true;

        var ids = [];
        var dId = sectionIdOf(drawerEl());
        var hId = sectionIdOf(headerEl());
        if (dId) ids.push(dId);
        if (hId) ids.push(hId);

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: qty }], sections: ids.join(',') })
        })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (data && data.sections) {
              if (dId) swap(data.sections[dId], dId);
              if (hId) swap(data.sections[hId], hId);
            }
            if (!openDrawer()) window.location.href = '/cart';
          })
          .catch(function () { window.location.href = '/cart'; })
          .then(function () {
            btn.disabled = false;
            if (label) label.textContent = old;
          });
      });
    });
  }

  /* ---------- 5. pasek dostepnosci ---------- */
  function stock() {
    $$('[data-mt-stock]').forEach(function (bar) {
      if (bar.__mt) return;
      bar.__mt = 1;
      var fill = $('[data-mt-fill]', bar);
      if (!fill) return;
      var pct = parseFloat(fill.getAttribute('data-pct') || '6');
      if (RM) { fill.style.width = pct + '%'; return; }
      var io = new IntersectionObserver(function (en) {
        en.forEach(function (e) {
          if (!e.isIntersecting) return;
          requestAnimationFrame(function () { fill.style.width = pct + '%'; });
          io.unobserve(e.target);
        });
      }, { threshold: 0.3 });
      io.observe(bar);
    });
  }

  /* ---------- 6. liczby rosnace od zera ---------- */
  function stats() {
    $$('[data-mt-count]').forEach(function (el) {
      if (el.__mt) return;
      el.__mt = 1;
      var raw = (el.getAttribute('data-mt-count') || '0').replace(',', '.');
      var target = parseFloat(raw) || 0;
      var dec = (raw.split('.')[1] || '').length;
      function fmt(v) { return v.toFixed(dec).replace('.', ','); }
      if (RM) { el.textContent = fmt(target); return; }
      el.textContent = fmt(0);
      var io = new IntersectionObserver(function (en) {
        en.forEach(function (e) {
          if (!e.isIntersecting) return;
          io.unobserve(e.target);
          var t0 = performance.now();
          (function step(t) {
            var p = Math.min(1, (t - t0) / 1200);
            var e2 = 1 - Math.pow(1 - p, 3);
            el.textContent = fmt(target * e2);
            if (p < 1) requestAnimationFrame(step);
          })(t0);
        });
      }, { threshold: 0.4 });
      io.observe(el);
    });
  }

  /* ---------- 7. przed / po ---------- */
  function beforeAfter() {
    $$('[data-mt-ba]').forEach(function (box) {
      if (box.__mt) return;
      box.__mt = 1;
      var layer = $('[data-mt-ba-top]', box);
      var handle = $('[data-mt-ba-h]', box);
      if (!layer || !handle) return;
      var dragging = false;
      function set(x) {
        var r = box.getBoundingClientRect();
        var p = Math.max(2, Math.min(98, ((x - r.left) / r.width) * 100));
        layer.style.clipPath = 'inset(0 ' + (100 - p) + '% 0 0)';
        handle.style.left = p + '%';
      }
      function down(e) { dragging = true; set(e.clientX != null ? e.clientX : e.touches[0].clientX); }
      function move(e) {
        if (!dragging) return;
        var x = e.clientX != null ? e.clientX : (e.touches && e.touches[0].clientX);
        if (x != null) { set(x); if (e.cancelable) e.preventDefault(); }
      }
      function up() { dragging = false; }
      box.addEventListener('pointerdown', down);
      window.addEventListener('pointermove', move, { passive: false });
      window.addEventListener('pointerup', up);
      box.addEventListener('click', function (e) { set(e.clientX); });
    });
  }

  /* ---------- 8. sciana opinii: kolumny w JS ---------- */
  /* column-count przy kazdym dolozeniu kart przelicza caly uklad i widoczne opinie skacza.
     Dlatego kolumny buduje JS i dokladamy karte zawsze na koniec najkrotszej kolumny. */
  function reviews() {
    var mas = $('[data-mt-mas]');
    if (!mas || mas.__mt) return;
    mas.__mt = 1;
    var all = $$('.mt-rv__c', mas);
    if (!all.length) return;
    var more = $('[data-mt-more]');
    var shown = Math.min(12, all.length);
    var cols = 0;

    function want() {
      var w = mas.clientWidth || mas.parentElement.clientWidth || 0;
      if (w >= 1000) return 4;
      if (w >= 760) return 3;
      if (w >= 260) return 2;
      return 1;
    }
    function build() {
      var n = want();
      if (n === cols) return;
      cols = n;
      mas.innerHTML = '';
      var boxes = [];
      for (var i = 0; i < n; i++) {
        var c = document.createElement('div');
        c.className = 'mt-mas__col';
        mas.appendChild(c);
        boxes.push(c);
      }
      mas.classList.add('is-ready');
      mas.__cols = boxes;
      place(0, shown);
    }
    function shortest() {
      var boxes = mas.__cols;
      var best = boxes[0];
      for (var i = 1; i < boxes.length; i++) {
        if (boxes[i].getBoundingClientRect().height < best.getBoundingClientRect().height) best = boxes[i];
      }
      return best;
    }
    function place(from, to) {
      for (var i = from; i < to && i < all.length; i++) {
        all[i].hidden = false;
        shortest().appendChild(all[i]);
      }
      if (more) more.hidden = to >= all.length;
    }
    build();
    if (more) {
      more.addEventListener('click', function () {
        var from = shown;
        shown = Math.min(all.length, shown + 8);
        place(from, shown);
      });
    }
    if (window.ResizeObserver) new ResizeObserver(function () { build(); }).observe(mas);
  }

  /* ---------- 9. pasek dolny ---------- */
  function stickyBar() {
    var bar = $('[data-mt-sticky]');
    var anchor = document.getElementById('mt-form');
    if (!bar || !anchor || bar.__mt) return;
    bar.__mt = 1;
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) {
        bar.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    io.observe(anchor);
  }

  /* ---------- 10. preferencje cookie ---------- */
  /* Przycisk renderujemy ZAWSZE. Adres /policies/#shopifyReshowConsentBanner to 404. */
  function cookiePrefs() {
    $$('[data-mt-cookie]').forEach(function (b) {
      if (b.__mt) return;
      b.__mt = 1;
      b.addEventListener('click', function () {
        var tries = 0;
        (function attempt() {
          if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
            window.privacyBanner.showPreferences();
            return;
          }
          if (++tries > 30) { window.location.href = '/policies/privacy-policy'; return; }
          setTimeout(attempt, 100);
        })();
      });
    });
  }

  /* Akordeony celowo NIE maja obslugi w JS — <details> przelacza sie natywnie.
     Wczesniejsza wersja przechwytywala klikniecie, zeby animowac zamykanie, i przez to
     akordeon w ogole sie nie zamykal. Rozwijanie animuje keyframe mt-open w mt.css. */

  function init() {
    countdown();
    gallery();
    buy();
    stock();
    stats();
    beforeAfter();
    reviews();
    stickyBar();
    cookiePrefs();
    reveal();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
